import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RekindleLove() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Rekindle a zealous love for the Lord" />
        <blockquote>“And He said to him, ‘”You shall love the Lord your God with all your heart, and with all your soul, and with all your mind”. This is the great and foremost commandment.’ ” (Matthew 22:37-38)</blockquote>

        <p>The ultimate goal in overcoming temptation is to get to the point where our love for the Lord motivates us to resist temptation, rather than our fear of punishment or getting caught. Loving the Lord is the greatest commandment. Our interest in the world and the flesh will diminish proportionately as our love for the Lord increases. This includes concern for His Name, not wanting to dishonor Him with our sin, and wanting to be spiritually strong so we are available for His work. As we love our neighbors as ourselves and as God has called us to love them, we will not sin against them. How can we be impatient and angry with someone if we have an attitude of love for them? How can we lust for another person if we are first and foremost concerned about their eternal destiny and the souls of those we will hurt if we are filled with lust? Lust is the opposite of love, as it is originates from extreme self-centeredness. When we consistently refuse the enticements of sin because we love and want to please the One who has created us and who has given His life for us, and because we love our neighbors as ourselves, then we are well on the way to victory in our struggle against sin.</p>

        <ul>
          <li><strong>Love the Lord with all your heart, soul, mind, and strength.</strong><br />
            <em>Deuteronomy 6:5, Psalm 31:23, Matthew 22:35-40</em>
          </li>

          <li><strong>Delight yourself in the Lord. Purpose to be a delight to Him, a person after His own heart.</strong><br />
            <em>1 Samuel 13:14, Psalm 37:4, 42:1-2, John 8:29, Acts 13:22, 2 Corinthians 5:9, Ephesians 5:10, Colossians 1:9-10, 1 John 3:22</em>
          </li>

          <li><strong>Purify your heart. Be not double-minded. Uproot the love of money and love of the world.</strong><br />
            <em>Proverbs 23:4-5, 28:22, Matthew 6:19-24, 1 Timothy 6:9-19, Hebrews 13:5, James 1:5-8, 4:4, 8-10, 1 John 2:15-17</em>
          </li>

          <li><strong>Fix your hope on Jesus Christ and His appearing, not on anything on this earth.</strong><br />
            <em>1 Timothy 6:17-19, 2 Timothy 4:8, Hebrews 12:1-2, 1 Peter 1:13, 1 John 3:3</em>
          </li>

          <li><strong>Set your heart to seek the Lord.</strong><br />
            <em>Deuteronomy 4:29-31, 2 Chronicles 12:14, Psalm 27:8, 34:10, 119:2, Isaiah 55:6</em>
          </li>

          <li><strong>Demonstrate your love for God by obedience to His Word. Do not leave your first love.</strong><br />
            <em>Deuteronomy 10:12-13, 11:1, 30:15-16, 1 Samuel 15:22-23, John 14:15, 21, 23, 1 John 2:4-6, 3:22-24, Revelation 2:4</em>
          </li>

          <li><strong>Demonstrate your love for God by loving the brethren.</strong><br />
            <em>John 15:12, 1 John 3:10-18, 23, 4:7, 19-21</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
